import type React from "react";
import {Tooltip} from "@mui/material";
import type {Cell} from "../contractExplorerTypes.ts";
import {formatNumber} from "../contractExplorerFormat.ts";

type Props = {
    value: unknown;
    cell: Cell | undefined;
    /** What to show instead of the bare number, such as `1,200 / year` or `12 %`. */
    text?: string;
};

/** A stated price, marked with what it was when it changed in this version. */
export const PriceCell: React.FC<Props> = ({value, cell, text}) => {
    const shown = text ?? formatNumber(value);
    if (cell?.change === 'changed') {
        return (
            <Tooltip arrow title={`Was ${formatNumber(cell.previous)} in the version before`}>
                <span className="ci-mono ci-changed-num">{shown}</span>
            </Tooltip>
        );
    }
    return <span className="ci-mono">{shown}</span>;
};
